"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const StaticWidgetRenderer_1 = tslib_1.__importDefault(require("./StaticWidgetRenderer"));
const GroupRenderer = (ctx) => ({
    renderV1(content, fetch) {
        return {
            type: "Group",
            value: content.value.map((items) => {
                return (0, StaticWidgetRenderer_1.default)(ctx).renderV1Object(items.value, fetch === null || fetch === void 0 ? void 0 : fetch.fields);
            }),
        };
    },
    renderV2(groupDef, content, fetch) {
        return content.value.map((items) => {
            var _a;
            return (0, StaticWidgetRenderer_1.default)(ctx).renderV2Object(items.value, fetch === null || fetch === void 0 ? void 0 : fetch.fields, ((_a = groupDef.config) === null || _a === void 0 ? void 0 : _a.fields) || {}, {
                withFetch: "filter",
            }, {
                default: "default",
                withFetch: "default",
                withFetchField: "default",
            });
        });
    },
    renderDefault() {
        return [];
    },
    renderMocks(def, content) {
        return content.value.map((items) => {
            var _a, _b;
            if (!((_a = def.config) === null || _a === void 0 ? void 0 : _a.fields))
                return {};
            return (0, StaticWidgetRenderer_1.default)(ctx).renderMocksObject(items.value, (_b = def.config) === null || _b === void 0 ? void 0 : _b.fields);
        });
    },
});
exports.default = GroupRenderer;
